export default __webpack_public_path__ + "static/media/ecosense-brand-logo-negative-white.36337e73.png";